import React from 'react';
import Anime from 'react-anime';
import './BottomPipe.scss';
export default ({ isActive, position }) => {
  const moveBall = {
    translateY: [
      { value: '-125vh', duration: 0},
      { value: '100vh', duration: 3000, easing: 'easeInSine'}
    ]
  }
  return (
    <div className={`bottom-pipe ${position}`}>
      <div className="pipe-container">
        <div className="pipe-cap"></div>
        <div className="pipe"></div>
        {isActive && (
          <Anime {...moveBall} className="ball">
            <div></div>
          </Anime>
        )}
      </div>
    </div>
  )
}